import React, { useState, useEffect } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { toast } from 'react-toastify';

const ZonePropertiesModal = ({ isOpen, zone, isSpecial = false, onClose, onSaved, onDeleted }) => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const isEdit = !!zone;

  useEffect(() => {
    if (isOpen) {
      setName(zone ? zone.name : '');
      setColor(zone?.color || '');
    }
  }, [isOpen, zone]);

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error('Zone name is required');
      return;
    }

    setSaving(true);
    try {
      if (isEdit) {
        const res = await callAPI(
          apiUrls.ZONES_UPDATE,
          {},
          'POST',
          { id: zone.id, name: trimmed, color: color || null },
          {}
        );
        onSaved(res.data.data, false);
        toast.success('Zone updated');
      } else {
        const res = await callAPI(
          apiUrls.ZONES_CREATE,
          {},
          'POST',
          { name: trimmed, color: color || null },
          {}
        );
        onSaved(res.data.data, true);
        toast.success('Zone created');
      }
    } catch (err) {
      const message = err.response?.data?.errors?.name?.[0] || err.response?.data?.message || 'Failed to save zone';
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!isEdit) return;
    setDeleting(true);
    try {
      await callAPI(apiUrls.ZONES_DELETE, {}, 'POST', { id: zone.id }, {});
      toast.success('Zone deleted');
      onDeleted(zone.id);
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error(err.response.data?.message || 'Zone still has tables — move or delete them first');
      } else {
        toast.error('Failed to delete zone');
      }
    } finally {
      setDeleting(false);
    }
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="zonePropertiesModal">
      <div className="modal-header">
        <h5 className="modal-title">{isSpecial ? 'Edit Category' : isEdit ? 'Edit Zone' : 'Add Zone'}</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Zone name (e.g. Garden Room)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isSpecial}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Color</label>
          <input
            type="color"
            className="form-control form-control-color"
            value={color || '#2a2a2a'}
            onChange={(e) => setColor(e.target.value)}
          />
        </div>
      </div>

      <div className="modal-footer justify-content-center">
        {isEdit && !isSpecial && (
          <button className="btn btn-danger" onClick={handleDelete} disabled={deleting || saving}>
            {deleting ? 'Deleting...' : 'Delete Zone'}
          </button>
        )}
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button className="btn btnPrimary" onClick={handleSave} disabled={saving || deleting}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </CommonModal>
  );
};

export default ZonePropertiesModal;
